export const DEFAULT_LAYER_WIDTH = 200;
export const DEFAULT_LAYER_HEIGHT = 300;

export const HORIZONTAL_AXIS_MARGIN = 40;
export const VERTICAL_AXIS_MARGIN = 30;

export const EXAGGERATED_DIAMETER = 100;
export const HOLE_OUTLINE = 0.6;
export const SCREEN_OUTLINE = 0.3;

export const SHOE_WIDTH = 8;
export const SHOE_LENGTH = 16;

export const DEFAULT_TEXTURE_SIZE = 64;

// Surface lines are drawn as LINES and not TRIANGLE_STRIP so width can only be 1
export const SURFACE_LINE_WIDTH = 1;
